<div class="d-flex flex-column h-100">
    <div class="flex-grow-1 overflow-auto">
        <div class="w-100 p-3">
            <div class="header mb-3">
                <div class="container-fluid">
                    <div class="row d-flex align-items-center solar-card">
                        <div class="col-auto px-0 text-center">
                            <span class="fa-stack">
                                <i class="fa fa-circle-thin fa-stack-2x"></i>
                                <i class="fa fa-info fa-stack-1x"></i>
                            </span>
                        </div>
                        <div class="col">
                            <p>
                                Cet outil propose une estimation simplifiée d’un emprunt bancaire
                                afin de fournir des ordres de grandeur sur le coût du financement.
                                Vous pouvez ajuster les conditions pour tester différents scénarios.
                            </p>
                            <p>
                                Cette simulation ne remplace en aucun cas une étude réalisée par un
                                établissement bancaire. Le taux et la durée proposés par défaut sont
                                définis à partir de conditions observées actuellement sur le marché.
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            <div class="body">
                <div class="container-fluid solar-card bank-loan-container">
                    <h5 class="text-st-primary mb-3">Je simule mon emprunt bancaire</h5>

                    <div>
                        Le montant de l'investissement initial du projet est de l'ordre de
                        <span class="text-st-active">{{ initInvestmentStringified }} €</span>
                        @if (bonusStringified) { @if (isPvSurplus) {, après déduction des
                        <span class="text-st-active">{{ bonusStringified }} €</span> de prime à
                        l'autoconsommation. } @else {, après déduction des
                        <span class="text-st-active">{{ bonusStringified }} €</span> d'aides. } }
                        @else {. }
                    </div>

                    <form [formGroup]="bankLoanFormGroup" class="container-fluid bank-loan-form">
                        <div class="row d-flex align-items-center">
                            <label for="loan" class="col-sm control-label text-start fw-normal">
                                Montant emprunté
                            </label>
                            <div class="col-sm-5">
                                <div class="row d-flex align-items-center">
                                    <div class="col">
                                        <stInput
                                            #loanInput
                                            formControlName="loan"
                                            innerId="loan"
                                            class="primary"
                                            type="number"
                                            [min]="1"
                                            [step]="1"
                                            [isInvalid]="loanControl!.invalid"
                                        >
                                        </stInput>
                                    </div>
                                    <div class="col-sm-3">€</div>
                                </div>
                            </div>
                        </div>

                        <div class="warning-container" *ngIf="showWarning$ | async">
                            <div class="alert">
                                <i class="bi bi-exclamation-triangle fa-2x"></i>
                                <div>
                                    Attention, le montant emprunté est supérieur au coût total du
                                    projet.
                                </div>
                            </div>
                        </div>

                        <div class="row d-flex align-items-center">
                            <label
                                for="duration-year"
                                class="col-sm control-label text-start fw-normal"
                            >
                                Durée (années)
                            </label>
                            <div class="col-sm-5">
                                <div class="row d-flex align-items-center">
                                    <div class="col">
                                        <stInput
                                            formControlName="durationYear"
                                            innerId="duration-year"
                                            class="primary"
                                            type="number"
                                            [min]="1"
                                            [step]="1"
                                            [isInvalid]="durationYearControl!.invalid"
                                        >
                                        </stInput>
                                    </div>
                                    <div class="col-sm-3">an(s)</div>
                                </div>
                            </div>
                        </div>

                        <div class="row d-flex align-items-center">
                            <label
                                for="annual-interest-rate"
                                class="col-sm control-label text-start fw-normal"
                            >
                                Taux d'intérêt annuel
                            </label>
                            <div class="col-sm-5">
                                <div class="row d-flex align-items-center">
                                    <div class="col">
                                        <stInput
                                            formControlName="annualInterestRate"
                                            innerId="annual-interest-rate"
                                            class="primary"
                                            type="number"
                                            [min]="1"
                                            [step]="0.1"
                                            [isInvalid]="annualInterestRateControl!.invalid"
                                        >
                                        </stInput>
                                    </div>
                                    <div class="col-sm-3">%</div>
                                </div>
                            </div>
                        </div>
                    </form>

                    <stButton
                        class="btn-st-lg btn-calc-bank-loan"
                        btnClass="btn-st-primary"
                        btnLabel="Calculer"
                        [isDisabled]="!isFormValid"
                        (onClick)="simulateBankLoad()"
                    >
                    </stButton>

                    @if (isSimulated) {
                    <div>
                        <p>
                            Le recours à un emprunt bancaire de
                            <span class="text-st-active">{{loanStringified}} €</span>, sur
                            <span class="text-st-active">{{durationYearStringified}} ans</span> à
                            <span class="text-st-active">{{annualInterestRateStringified}}%</span>
                            représente un coût total du crédit d'environ
                            <span class="text-st-active">{{creditCostStringified}} €</span>
                            dont
                            <span class="text-st-active">{{interestStringified}} €</span>
                            d'intérêts soit des mensualités de
                            <span class="text-st-active">{{monthlyPaymentStringified}} €</span>.
                        </p>
                        <p>
                            Avec l'emprunt bancaire, le montant du projet est de l'ordre de
                            <span class="text-st-active">{{newInvestmentStringified}} €</span>
                            soit un temps de retour sur investissement de
                            <span class="text-st-active">{{roiStringified}} ans</span> (sans emprunt
                            bancaire le temps de retour sur investissement est de
                            <span class="text-st-active">{{initRoiStringified}} ans</span>).
                        </p>
                    </div>
                    }
                </div>
            </div>
        </div>
    </div>

    <div class="footer border-top">
        <div class="container-fluid py-3">
            <div class="row">
                <div class="col-5">
                    <stButton
                        class="btn-st-lg"
                        btnClass="btn-st-default w-100 h-100"
                        btnLabel="Retour"
                        (onClick)="cancel()"
                    >
                    </stButton>
                </div>
                <div class="col-7">
                    <stButton
                        class="btn-st-lg"
                        btnClass="btn-st-primary w-100"
                        btnLabel="Voir les résultats"
                        [isDisabled]="!isSimulated"
                        (onClick)="validate()"
                    >
                    </stButton>
                </div>
            </div>
        </div>
    </div>
</div>
